export default "__VITE_ASSET__y8fL0GYx__"